// import { Message } from "./Message";
import { Message } from "./Mesaage";

export const TodayThread = () => (
  <section className="flex flex-col gap-6 items-start w-full">
    <Message
      author="Phoenix Baker"
      time="Friday 2:20pm"
      content="Hey Olivia, can you please review the latest design when you can?"
      image="https://cdn.builder.io/api/v1/image/assets/TEMP/88e80815a8b41d0c1a325079c00b65b9a893cdab"
      isOutgoing={false}
    />
    <Message
      author="You"
      time="Friday 2:20pm"
      content="Sure thing, I'll have a look today."
      isOutgoing={true}
    />
  </section>
);
